module.exports = __webpack_public_path__ + "static/media/logo-white.416ad5a6.svg";